<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
  >
    <path
      d="M4.55026 16.7497H16.4504C18.0364 16.7497 18.8337 15.9846 18.8337 14.4537V6.55392C18.8337 5.02305 18.0364 4.25 16.4504 4.25H4.55026C2.96422 4.25 2.16699 5.02305 2.16699 6.55392V14.4537C2.16699 15.9846 2.9639 16.7497 4.55026 16.7497ZM3.38906 6.62114C3.38906 5.84809 3.81423 5.44698 4.57292 5.44698H16.4352C17.1864 5.44698 17.6116 5.84809 17.6116 6.62114V7.24516H3.38906V6.62114ZM4.57292 15.554C3.81391 15.554 3.38906 15.1598 3.38906 14.3871V8.93203H17.6116V14.3868C17.6116 15.1595 17.1864 15.5537 16.4352 15.5537L4.57292 15.554ZM5.4456 13.3537H7.30526C7.75309 13.3537 8.04906 13.0639 8.04906 12.6403V11.2654C8.04906 10.8494 7.75309 10.552 7.30526 10.552H5.4456C4.99777 10.552 4.7018 10.8494 4.7018 11.2654V12.6403C4.7018 13.0639 4.99777 13.3537 5.4456 13.3537Z"
      fill="currentColor"
    />
  </svg>
</template>
